import * as Yup from "yup";

export const personalDataValidationSchema = Yup.object({
  name: Yup.string()
    .required("Nome completo é obrigatório.")
    .transform((value) => value.trim())
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    )
    .test(
      "valid-full-name",
      "Insira pelo menos dois nomes.",
      (value) => value ? value.trim().split(" ").length > 1 : false
    ),

  birthDate: Yup.string()
    .required("Data de nascimento é obrigatória")
    .matches(
      /^([0-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/,
      "Data de nascimento inválida"
    )
    .test("valid-date", "Data de nascimento inválida", (value) => {
      if (!value) return false;
      const [day, month, year] = value.split("/").map(Number);
      const date = new Date(year, month - 1, day);
      return (
        date &&
        date.getDate() === day &&
        date.getMonth() === month - 1 &&
        date.getFullYear() === year
      );
    }),

  cellphone: Yup.string()
    .required("Celular é obrigatório")
    .matches(
      /^\(\d{2}\) \d{5}-\d{4}$/,
      "Formato inválido. Use (XX) XXXXX-XXXX"
    ),

  motherName: Yup.string()
    .required("Nome completo é obrigatório.")
    .transform((value) => value.trim())
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    )
    .test(
      "valid-full-name",
      "Insira pelo menos dois nomes.",
      (value) => value ? value.trim().split(" ").length > 1 : false
    ),
});
export const addressValidationSchema = Yup.object({
  street: Yup.string()
    .required("Rua é obrigatória")
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    ),

  streetNumber: Yup.number().required("Número é obrigatório"),

  cep: Yup.string().required("CEP é obrigatório"),
  district: Yup.string()
    .required("Bairro é obrigatório")
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    ),
  complement: Yup.string(),
  city: Yup.string()
    .required("Cidade é obrigatória")
    .test(
      "no-special-characters",
      "Contém caracteres especiais ou números.",
      (value) => !value || /^[A-Za-zÀ-ÿàèìòùÃãÊêÕõ~\s]+$/.test(value)
    ),
});

export const bankDataValidationSchema = Yup.object().shape({
  pixType: Yup.string().nullable().required("Forma do Pix é obrigatória"),

  pixKey: Yup.string()
    .nullable()
    .when("pixType", {
      is: (value: string | null) =>
        value !== "BANK_ACCOUNT" && value != null,
      then: (schema) => schema.required("Chave Pix é obrigatória"),
      otherwise: (schema) => schema.nullable(),
    }),

  accountType: Yup.string()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) => schema.required("Tipo de conta é obrigatório"),
      otherwise: (schema) => schema.nullable(),
    }),

  bankCode: Yup.string()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) => schema.required("Banco é obrigatório"),
      otherwise: (schema) => schema.nullable(),
    }),

  agency: Yup.string()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) =>
        schema
          .required("Agência é obrigatória")
          .matches(/^\d{4}$/, "Agência deve ter exatamente 4 dígitos")
          .typeError("Agência deve ser um número"),
      otherwise: (schema) => schema.nullable(),
    }),

  account: Yup.number()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) =>
        schema
          .required("Número da conta é obrigatório")
          .typeError("Número da conta deve ser um número")
          .positive("Número da conta deve ser um número positivo")
          .integer("Número da conta deve ser um número inteiro"),
      otherwise: (schema) => schema.nullable(),
    }),

  digit: Yup.string()
    .nullable()
    .when("pixType", {
      is: "BANK_ACCOUNT",
      then: (schema) => schema.required("Dígito é obrigatório"),
      otherwise: (schema) => schema.nullable(),
    }),
});
